import { render, staticRenderFns } from "./EmailConfigEditor.vue?vue&type=template&id=34ddf000&"
import script from "./EmailConfigEditor.vue?vue&type=script&lang=js&"
export * from "./EmailConfigEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports